import { memo } from 'react';

import AdminIconSVG from '@/assets/admin-icon.svg?react';
import { Icon, IconProps } from '@/components/core';

const IAdminIcon = (props: Omit<IconProps, 'SVGComponent'>) => <Icon SVGComponent={AdminIconSVG} {...props} />;

export const AdminIcon = memo(IAdminIcon) as typeof IAdminIcon;
